import React, { useEffect, useRef } from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import ProductTableV2 from '../Generate/components/ProductTableV2';
import { Box } from '@mui/material';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import colors from 'src/utils/colors';
import { useContentGenerationStore } from '../Generate/components/ProductTable/store';
import { useProjects } from './hooks/useProjects';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { useProjectFlowStore } from '../stores/projectFlowStore';

export const ProjectProducts: React.FC = () => {
  const { selectedItems, setSelectedItems } = useContentGenerationStore();
  const { selectedRetailerSkus: persistedSelectedSkus, setSelectedRetailerSkus: setPersistedSelectedSkus } = useProjectFlowStore();
  const hasRestoredSelectionsRef = useRef(false);
  useEffect(() => {
    if (persistedSelectedSkus.length > 0 && !hasRestoredSelectionsRef.current) {
      setSelectedItems(new Set(persistedSelectedSkus));
      hasRestoredSelectionsRef.current = true;
    }
  }, [persistedSelectedSkus, setSelectedItems]);

  useEffect(() => {
    const skusArray = Array.from(selectedItems);
    setPersistedSelectedSkus(skusArray);
  }, [selectedItems, setPersistedSelectedSkus]);

  // Use projects hook - don't require projectId since this is used during new project creation
  const { navigateToProjectSettings, navigateToProjectReview } = useProjects({
    syncUrlParams: true,
    requireProjectId: false
  });

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={8} marginBottom="32px">
        <Text variant="h4">Products</Text>
        <Text variant="body1">
          Select the products you would like to include in this project to generate new content.
        </Text>
      </Flex>
      <Box width="100%">
        <ProductTableV2 />
      </Box>

      <Flex justifyContent="space-between" sx={{ marginTop: '64px', marginBottom: '48px' }}>
        <SlButton
          variant="normal"
          onClick={() => navigateToProjectSettings('create')}
          buttonSx={{
            border: `1px solid ${colors.graysSecondary}`
          }}
        >
          Back
        </SlButton>
        <SlButton variant="contained" onClick={() => navigateToProjectReview('create')} disabled={selectedItems.size === 0}>
          Next
        </SlButton>
      </Flex>
    </BasePageContainer>
  );
};
